import type { PropertyDetailListing } from '@/src/components/features/property/types';

type RoomForRentLike = {
  roommateDetails?: {
    description?: string;
    roommatesInfo?: string;
    petsInfo?: string;
  };
  preferredNewRoommate?: string;
};

export type HousemateDetailsDisplay = {
  description?: string;
  roommatesInfo?: string;
  petsInfo?: string;
  preferredNewRoommate?: string;
  hasDetails: boolean;
};

export const getHousemateDetailsDisplay = (
  listing: PropertyDetailListing | null | undefined,
): HousemateDetailsDisplay => {
  const roomForRent = (listing?.details as { roomForRent?: RoomForRentLike } | undefined)?.roomForRent;
  const description = roomForRent?.roommateDetails?.description;
  const roommatesInfo = roomForRent?.roommateDetails?.roommatesInfo;
  const petsInfo = roomForRent?.roommateDetails?.petsInfo;
  const preferredNewRoommate = roomForRent?.preferredNewRoommate;

  return {
    description,
    roommatesInfo,
    petsInfo,
    preferredNewRoommate,
    hasDetails: Boolean(description || roommatesInfo || petsInfo || preferredNewRoommate),
  };
};

export const hasHousemateDetails = (listing: PropertyDetailListing | null | undefined): boolean =>
  getHousemateDetailsDisplay(listing).hasDetails;
